module.exports = __webpack_public_path__ + "static/media/xml.a03b766e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/xml.png
// module id = 2575
// module chunks = 0